import * as React from 'react';
import { Flex } from 'antd';
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { DivMinWidth, FlexPadStyled } from '../App';
import { LogoBC } from '../components/LogoBC';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { fonts } from '../assets/constStyles';
import dataMagazines from '../magazine_data.json';
import { MagazineType } from '../../../common/types';

interface MagazineItemPageProps {

}

export const MagazineItemPage: React.FC<MagazineItemPageProps> = () => {
  const urlParams = useParams();
  const htmlUrl = `https://d3cmk87qpxxsnb.cloudfront.net/${urlParams.id}/${urlParams.id}.html`;
  const [magazine] = (Array.from(Object.values(dataMagazines)) as MagazineType[]).filter((mag) => mag.id === urlParams.id);

  if (!magazine) {
    return <div>Magazine not found</div>;
  }

  return <>
      <Helmet>
          <title>{`Magazine-${magazine.year || ''}`}</title>
          <meta
              name="description"
              content="AWMAC - Architectural Woodwork Manufacturers Association of Canada AWARDS"
          />
          <link rel="canonical" href={`https://awmacbc.com/magazines/${magazine.id}`}/>
      </Helmet>
        <div style={{ position: 'relative' }}>
            <DivMinWidth>
                <div style={{ padding: '20px' }}>
                    <FlexPadStyled vertical>
                        <LogoBC/>
                    </FlexPadStyled>
                    <Flex style={{ margin: '20px 0' }}>
                        <Breadcrumbs/>
                    </Flex>
                    <h1 style={{ textAlign: 'center', fontFamily: fonts.font2, marginBottom: '20px' }}>
                        AWMAC AWARDS OF EXCELLENCE - Benchmark {magazine.caption}
                    </h1>
                    <Flex style={{
                      height: '100vh', overflow: 'hidden', padding: 30,
                    }}>
                        <div style={{ width: '100%', height: '90vh' }}>
                            <iframe
                                src={htmlUrl}
                                title={urlParams.id}
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                            />
                        </div>
                    </Flex>
                </div>
            </DivMinWidth>
        </div>
    </>;
};
